import { InjectionToken } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';
import { environment } from '../../environments/environment';

export const FIREBASE_CONFIGURED =
    environment.firebase.apiKey !== '' && environment.firebase.appId !== '';

export const FIREBASE_AUTH = new InjectionToken<Auth | null>('FIREBASE_AUTH', {
    providedIn: 'root',
    factory: () => {
        if (!FIREBASE_CONFIGURED) return null;
        return getAuth(initializeApp(environment.firebase));
    },
});
